import * as React from 'react';
import { IconButton, TextField, Typography } from '@mui/material';
import { MoreHoriz } from '@mui/icons-material';
import dayjs from 'dayjs';

import { Popup } from 'components';
import { IDecalOrderItemWithActions } from '../models/cart.model';
import { Decal } from '../components/decal';

export const convertItemsToTableData = (items: Array<IDecalOrderItemWithActions>) => {
  return items.map((item) => convertItemToTableData(item));
};

export const getItemTableRowOptions = (item: IDecalOrderItemWithActions) => {
  const { reviewDecal = () => {}, removeFromCart = () => {} } = item;

  const options: any[] = [
    {
      id: 2,
      label: item.decal_approved ? 'Review Decal' : 'Approve Decal',
      onClick: () => reviewDecal(item),
      visible: () => true,
    },
    {
      id: 3,
      label: 'Remove From Cart',
      onClick: () => removeFromCart(item),
      visible: () => true,
    },
  ];

  return options;
};

export const convertItemToTableData = (item: IDecalOrderItemWithActions) => {
  const options = getItemTableRowOptions(item);

  return {
    id: item.id,
    code: (
      <Typography color="primary" variant="body2" sx={{ cursor: 'pointer' }}>
        {item.code}
      </Typography>
    ),
    name: item.name,
    building: item.building?.address,
    quantity: (
      <TextField
        value={item.quantity}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
        size="small"
        sx={{ width: 50 }}
        onChange={(event) => {
          const value = event.target.value.replace(/\D/, '');
          if (value) {
            item.updateQuantity(item.id, +value);
          } else {
            item.updateQuantity(item.id, 0);
          }
        }}
      />
    ),
    decal: <Decal zoneId={item.id} />,
    decalApproved: item.decal_approved ? 'Yes' : 'No',
    decalApprovedAt: item.decal_approved_at ? dayjs(item.decal_approved_at).format('MM/DD/YYYY') : '',
    actions: (
      <Popup items={options.filter((o) => o.visible())} width={180}>
        <IconButton color="primary" size="small">
          <MoreHoriz />
        </IconButton>
      </Popup>
    ),
  };
};
